import React from 'react';
import { ScrollBackToTopContainer } from './styles';
import { BsChevronUp } from 'react-icons/bs';

const ScrollBackToTop = ({ scroll, show }) => {
  return (
    <ScrollBackToTopContainer onClick={() => scroll()} show={show} id="scrollback">
      <BsChevronUp size={32} id="chevron-icon" />
    </ScrollBackToTopContainer>
  )
}

export default ScrollBackToTop;
